import type { PurchaseOrderDetailsFormProps } from './types'

export const initialFormValues: PurchaseOrderDetailsFormProps = {
  filiCode: '',
  competenceDate: '',
  supplierCode: '',
  purchaseOrderNumber: '',
  origin: '',
  operation: '',
  classification: '',
  expectedDelivery: '',
  itemsQuantity: '',
  totalValue: '',
  nfItensQuantity: '',
  nfTotalValue: '',
  deviationItensQuantity: '',
  deviationTotalValue: '',
  transferItensQuantity: '',
  transferTotalValue: '',
  observations: '',
  itemClassification: ''
}
